import React, { useRef } from "react";
import { useMount } from "react-use";

import { useIncode } from "./IncodeContext";

export const TutorialPassport = () => {
  const containerRef = useRef(null);
  const { incode, token, navigateTo, track } = useIncode();

  useMount(() => {
    track("tutorial_passport_viewed");
    incode.renderPassportTutorial(containerRef.current, {
      token: { token },
      onSuccess: () => navigateTo("passport"),
      noWait: true,
    });
  });

  return <div ref={containerRef}></div>;
};
